import { motion } from "framer-motion";
import { IMAGES } from "../../lib/medskin-data";

export const About = () => {
  return (
    <section id="om" className="py-24 md:py-36 bg-[#F7F6F3]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 relative"
          >
            <div className="aspect-[4/5] rounded-[2rem] overflow-hidden">
              <img
                src={IMAGES.about}
                alt="Klinikk-interiør Medskinby"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
            <div className="absolute top-6 right-6 bg-[#F7F6F3]/90 backdrop-blur-md border border-[#E5E0DA] rounded-2xl px-5 py-3">
              <span className="text-[10px] uppercase tracking-[0.22em] text-[#635D56]">Oslo · Etbl. 2018</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#C4A981]"></span>
              <span className="text-[11px] uppercase tracking-[0.3em] text-[#635D56]">Om Medskinby</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl lg:text-[3.5rem] leading-[1.08] text-[#2C2C2A] tracking-tight font-light" data-testid="about-headline">
              En stille klinikk for huden som <em className="italic text-[#4A4238]">krever mer</em>.
            </h2>
            <p className="mt-8 text-base md:text-lg text-[#635D56] font-light leading-relaxed max-w-2xl" data-testid="about-paragraph">
              Medskinby er en klinisk hudklinikk i Oslo med fokus på langsiktig hudhelse. Vi kombinerer
              medisinsk kunnskap med en helhetlig tilnærming for å behandle huden på et dypere nivå –
              med ro, presisjon og varig effekt.
            </p>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl">
              {[
                "Medisinsk faglig grunnlag i hver behandling",
                "Diskret, rolig og personlig atmosfære",
                "Skreddersydde, evidensbaserte protokoller",
                "Lang erfaring med komplekse hudtilstander",
              ].map((t) => (
                <div key={t} className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#C4A981] shrink-0"></span>
                  <span className="text-sm text-[#2C2C2A] font-light leading-relaxed">{t}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
